<template>
    <div class="dark-select">
        <geo-map ref="basicMap" :height="'100%'" style="background: #044061"></geo-map>
        <a-select class="station-type" v-model="type"  defaultValue="0"  style="width: 130px" @change="handleChange" :getPopupContainer="
          triggerNode => {
            return triggerNode.parentNode || document.body;
          }
        ">
            <a-select-option value="0">全部类型</a-select-option>
            <a-select-option value="1">分布式自发自用</a-select-option>
            <a-select-option value="2">集中式场站</a-select-option>
            <a-select-option value="3">分布式全额上网</a-select-option>
            <a-select-option value="4">户用电站</a-select-option>
        </a-select>
        <div class="more" @click="getMore()">
            <div class="more-content">
                <i class="fa fa-th"></i>
                <div class="more-text">更多</div>
            </div>
        </div>
    </div>

</template>

<script>

    import GeoMap from "@/components/Map/GeoMap";
    export default {
        name: "mapInfo",
        components:{
            GeoMap
        },
        data(){
            return {
                mapChart: null,
                user: null,
                type: '0',
                mapList: []
            }
        },
        mounted() {
            this.user = this.$Utils.getUserStorage();
            this.getMapChart();
            this.getStationInfo();
        },
        methods:{
            getMapChart(){
                this.mapChart = this.$refs.basicMap.$refs.mapEcharts.myChart;
                this.$refs.basicMap.initMap();
                this.mapChart.on('click', (param) => {
                    //console.log(param);
                    if(param.name !== '南海诸岛'){
                        this.$refs.basicMap.refreshMap(param.name);
                    }
                    if(param.componentSubType === 'effectScatter'){
                        this.getClickStation(param.componentIndex);
                    }
                });
            },
            async getStationInfo(){
                let result = await this.$http.get(this.$baseURL.stationNoChildList({group: this.user.groupId, type: this.type}));
                console.log(result)
                this.mapList = result;
                this.$refs.basicMap.setMapData(result)
            },
            getClickStation(index){
                console.log(this.mapList[index])
                this.$emit('clickPowerStation', this.mapList[index]);
            },
            handleChange(){
                this.getStationInfo();
            },
            getMore(){
                this.$emit('getMore', 1)
            }
        }
    }
</script>

<style  lang="less" scoped>
    .dark-select {
        height: 100%;
        position: relative;;
        .station-type {
            position: absolute;
            right: 5%;
            top: 10%;
        }

        /deep/ .ant-select-selection {
            background: #044061;
            color: #eee;
            border: 1px solid @primary-color;
        }
        /deep/ .ant-select-arrow .ant-select-arrow-icon {
            color: @primary-color;
        }
        /deep/ .ant-select-dropdown{
            background: #044061;

            .ant-select-dropdown-menu-item {
                color: #eee;
            }
        }
        /deep/ .ant-select-dropdown-menu-item-selected, /deep/ .ant-select-dropdown-menu-item-selected:hover{
            background: @primary-color;
            color: #eee;
        }
        /deep/ .ant-select-dropdown-menu-item-active:hover{
            background: @primary-color;
            color: #eee;
        }
    }

    .more {
        position: absolute;
        bottom: 5%;
        right: 3%;
        width: 150px;
        height: 150px;
        background: #005365;
        display: flex;
        justify-content: center;
        align-items: center;
        border-radius: 5px;

        .more-content {
            text-align: center;
            font-size: 18px;
            color: #eee;
            i {
                font-size: 60px;
                color: rgba(255,255,255,0.5);
            }
        }
        &:hover{
            cursor: pointer;
            animation: changeBigger 0.5s forwards;
        }
    }

    @keyframes changeBigger {
        0%{
            transform: scale(1);
        }
        100%{
            transform: scale(1.1);
        }
    }
</style>
